import React from 'react';

type ConfirmationDialogProps = {
  action?: [];
  onClickAccept: () => void;
  onCLickClose: () => void;
  title: string;
  description: string;
};

function ConfirmationDialog({
  onClickAccept,
  onCLickClose,
  title,
  description,
}: ConfirmationDialogProps) {
  return (
    <>
      <div className="fixed z-[9998] inset-0 bg-white bg-opacity-50 backdrop-blur-md" />
      <div className="justify-center z-[9999] items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none">
        <div className=" flex flex-col w-11/12 sm:w-5/6 lg:w-1/2 max-w-2xl mx-auto rounded-lg  shadow-xl">
          <div className="flex flex-row justify-between p-6 bg-white  rounded-tl-lg rounded-tr-lg">
            <p className="font-semibold text-gray-800">{title}</p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-10 h-10 stroke-white fill-primary self-end cursor-pointer"
              onClick={onCLickClose}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <div className="flex flex-row items-center justify-between p-5 bg-white  rounded shadow-sm">
            <div className="flex flex-row items-center">{description}</div>
          </div>

          <div className="flex flex-row items-center justify-center p-5  bg-gray-50 rounded-bl-lg rounded-br-lg">
            <button
              className=" px-4 py-2   font-medium   rounded "
              onClick={onCLickClose}
            >
              Annuler
            </button>
            <button
              className="ml-5 px-4 py-2 text-white  font-medium bg-red-500 rounded "
              onClick={onClickAccept}
            >
              Confirmer
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ConfirmationDialog;
